import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/image/no_data1.png'


const _hoisted_1 = { class: "address-list-modal-content" }
const _hoisted_2 = { class: "address-content" }
const _hoisted_3 = { class: "country" }
const _hoisted_4 = { style: {"margin-left":"6px"} }
const _hoisted_5 = { class: "address line--only" }
const _hoisted_6 = { class: "user-info" }
const _hoisted_7 = { class: "address-btn" }
const _hoisted_8 = {
  key: 0,
  class: "no-data"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "no-data-img",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_10 = { class: "rel" }

import { t } from '@/plugins/i18n'
import CommonDialog from '@/components/common/CommonDialog.vue'
import { ref } from 'vue'
import AddressDialog from './AddressDialog.vue'
import { getShopcartAddressListApi, delShopcartAddressListApi } from '@/apis/shopcart'
import confirmDialog from '@/components/common/ConfirmDialog'
import { ElMessage } from 'element-plus'
import { getTotalCountryList } from '@/util/useCountry'
import { getExpressAllCountryListApi } from '@/apis/user'
import { getWarehouseCode, useSite2Station } from '@/store'


export default /*#__PURE__*/_defineComponent({
  props: ['countryList'],
  emits: ['submit'],
  setup(__props, { expose, emit: emits }) {

const props = __props


const addressItem: any = ref({})
const visible = ref(false)
const addressVisible = ref(false)
const addressId = ref('')
const addressList: any = ref([])
const addressDialogRef = ref()
const open = () => {
  visible.value = true
  getList()
}
const getList = () => {
  getShopcartAddressListApi().then((res) => {
    addressList.value = res.data
  })
}
const edit = (v: any = {}) => {
  addressItem.value = v
  addressVisible.value = true
}
const del = async (v: { id: string }) => {
  confirmDialog({
    title: t('提示'),
    text: t('确定删除此地址')
  }).then(async () => {
    console.log(1111)
    const { success } = await delShopcartAddressListApi({
      id: v.id
    })
    if (success) {
      ElMessage.success(t('删除成功'))
      getList()
    }
  })
}
const submit = () => {
  if (!addressId.value) {
    ElMessage.warning(t('请选择要导入的地址'))
    return
  }
  const address = addressList.value.find((v) => v.id === addressId.value)
  if (props.countryList.find((v) => v.code === address.countryCode)) {
    emits('submit', address)
    visible.value = false
    return
  }
  ElMessage.warning(t('不支持发送当前国家'))
}
expose({
  open
})

const countryList: any = ref([])
const totalCountryList: any = ref([])
const init = async () => {
  const totalCountry: any = await getTotalCountryList()
  totalCountryList.value = totalCountry
  // 筛选配置的国家信息
  // 默认为当前站点下的国家
  // 获取国家列表
  const { data } = await getExpressAllCountryListApi({
    stationCode: useSite2Station(),
    warehouseCode: getWarehouseCode(false)
  })
  const codes = data.map((i: any) => i.countryCode)
  countryList.value = totalCountry.filter((i: any) => codes.indexOf(i.code) > -1)
}
init()

const phoneArea = (v: string) => {
  const areaNum = totalCountryList.value.find((item: { code: string }) => item.code === v)?.areaNum ?? ''
  return areaNum ? `+${areaNum} ` : ''
}

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CommonDialog, {
      visible: visible.value,
      className: "address-list-modal",
      title: _unref(t)('导入常用地址'),
      width: 640,
      footer: true,
      onCancel: _cache[2] || (_cache[2] = ($event: any) => (visible.value = false)),
      onOk: submit
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_radio_group, {
            modelValue: addressId.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((addressId).value = $event))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addressList.value, (v) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex-ter-bwn",
                  key: v
                }, [
                  _createVNode(_component_el_radio, {
                    label: v.id,
                    disabled: !countryList.value.find(item => item.code === v.countryCode)
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("span", null, _toDisplayString(v.countryJp), 1),
                          _createElementVNode("span", _hoisted_4, _toDisplayString(v.postalCode), 1)
                        ]),
                        _createElementVNode("div", _hoisted_5, _toDisplayString(v.provinceJp) + _toDisplayString(v.cityJp) + _toDisplayString(v.address), 1),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("span", null, _toDisplayString(v.receiveName), 1),
                          _createElementVNode("span", null, _toDisplayString(phoneArea(v.countryCode)) + _toDisplayString(v.receiveTel), 1)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["label", "disabled"]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_el_button, {
                      type: "text",
                      onClick: ($event: any) => (del(v))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('删除')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_button, {
                      type: "text",
                      onClick: ($event: any) => (edit(v)),
                      disabled: !countryList.value.find(item => item.code === v.countryCode)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('编辑')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick", "disabled"])
                  ])
                ]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (addressList.value?.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", null, _toDisplayString(_unref(t)('暂无数据')), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_button, {
            type: "text",
            class: "add-link-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (edit()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('新增地址')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    (addressVisible.value)
      ? (_openBlock(), _createBlock(AddressDialog, {
          key: 0,
          visible: addressVisible.value,
          "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((addressVisible).value = $event)),
          title: addressItem.value.id ? _unref(t)('修改地址') : _unref(t)('新增地址'),
          form: addressItem.value,
          ref: (_value, _refs) => {
            _refs['addressDialogRef'] = _value
            addressDialogRef.value = _value
          },
          onSuccess: getList,
          countryList: countryList.value
        }, null, 8, ["visible", "title", "form", "countryList"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})